// App.js
import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';

import './styles/App.css';

import Navbar from './components/Navbar';
import Home from './components/Home';
import About from './components/About';
import Projects from './components/Projects';
import ProjectDetails from './components/ProjectDetails'; // ✅ NEW
import VolunteerForm from './components/VolunteerForm';
import Donate from './components/Donate';
import ContactForm from './components/ContactForm';
import Footer from './components/Footer';

function App() {
  return (
    <BrowserRouter>
      <div className="app-root">
        <Navbar />

        <main>
          <Routes>
            {/* Home (default) */}
            <Route path="/" element={<Home />} />

            {/* About */}
            <Route path="/about" element={<About />} />

            {/* Projects list */}
            <Route path="/projects" element={<Projects />} />

            {/* Project details with gallery */}
            <Route path="/project/:projectId" element={<ProjectDetails />} />

            {/* Volunteer */}
            <Route path="/volunteer" element={<VolunteerForm />} />

            {/* Donate */}
            <Route path="/donate" element={<Donate />} />

            {/* Contact */}
            <Route path="/contact" element={<ContactForm />} />

            {/* Fallback: unknown routes → Home or 404 */}
            <Route path="*" element={<Home />} />
          </Routes>
        </main>

        <Footer />
      </div>
    </BrowserRouter>
  );
}

export default App;
